import React, { useState, useEffect } from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import RouteSeo from "./seo/RouteSeo";
//Preloader
import Preloader from "./Components/Preloader/Preloader";
import Home from "./Components/Home/Home";
import Apply from "./Components/ApplyJob/Apply";
import AboutUs from "./Components/AboutUs/About";
import ContactUs from "./Components/ContactUs/ContactUs";
// Services Start
import PermanentStaffing from "./Components/Services/PermanentStaffing";
import TemporaryStaff from "./Components/Services/TemporaryStaff";
import PayRoll from "./Components/Services/PayRoll";
import International from "./Components/Services/International";
import DedicatedIt from "./Components/Services/DedicatedIt";
import Executive from "./Components/Services/Executive";
import BulkHiring from "./Components/Services/BulkHiring";
import Services from "./Components/Services/MainServices";
import ServicesGallery from "./Components/Services/ServicesGallery";
import ServiceDetails from "./Components/Services/ServiceDetails";
import VisaAssistance from "./Components/Services/VisaAssistance";
// Services End
import Blog from "./Components/Blog/Blog";
import EditorialArticle from "./Components/Blog/EditorialArticle";
//Full Blogs
import Careers from "./Components/Careers/Careers";
import Resources from "./Components/Resources/Resources";

import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
// Agreements
import Privacypolicy from "./Components/Agreements/Privacypolicy";
import TermsConditions from "./Components/Agreements/TermsConditions";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      setLoading(false);
    }, 2400);
    return () => window.clearTimeout(timerId);
  }, []);
  return (
    <HelmetProvider>
      <div className="App">
        {loading ? ( // Conditionally render the preloader
          <Preloader />
        ) : (
          <BrowserRouter>
            <RouteSeo />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ApplyJob" element={<Apply />} />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/ContactUs" element={<ContactUs />} />
              {/* Services */}
              <Route path="/Services" element={<Services />} />
              <Route path="/services-gallery" element={<ServicesGallery />} />
              <Route path="/service-details/:serviceId" element={<ServiceDetails />} />
              <Route path="/VisaAssistance" element={<VisaAssistance />} />
              <Route path="/PermanentStaffing" element={<PermanentStaffing />} />
              <Route path="/TemporaryStaffing" element={<TemporaryStaff />} />
              <Route path="/PayRoll" element={<PayRoll />} />
              <Route path="/DedicatedIt" element={<DedicatedIt />} />
              <Route path="/International" element={<International />} />
              <Route path="/Executive" element={<Executive />} />
              <Route path="/BulkHiring" element={<BulkHiring />} />
              {/* Services */}
              <Route path="/Blog" element={<Blog />} />
              {/* Full Blogs */}
              <Route path="/QuestionOne" element={<EditorialArticle />} />
              <Route path="/QuationTwo" element={<EditorialArticle />} />
              <Route path="/Quationthere" element={<Navigate to="/Blog" replace />} />
              <Route path="/QuationFour" element={<Navigate to="/Automation" replace />} />
              <Route path="/QuationFive" element={<Navigate to="/Blog" replace />} />
              <Route path="/QuationSix" element={<Navigate to="/Internal-Momentum" replace />} />
              <Route path="/QuationSeven" element={<Navigate to="/Blog" replace />} />
              <Route path="/FullBlog" element={<Navigate to="/Blog" replace />} />
              <Route path="/FullBlog/:id" element={<Navigate to="/Blog" replace />} />
              <Route path="/blog/:id" element={<Navigate to="/Blog" replace />} />
              <Route path="/Careers" element={<Careers />} />
              <Route path="/Resources" element={<Resources />} />
              <Route path="/Resources/:slug" element={<Resources />} />
              <Route path="/Generative-AI" element={<EditorialArticle />} />
              <Route path="/Automation" element={<EditorialArticle />} />
              <Route path="/Surprising25" element={<Navigate to="/Blog" replace />} />
              <Route path="/Proven" element={<EditorialArticle />} />
              <Route path="/Internal-Momentum" element={<EditorialArticle />} />
              <Route path="/Changed" element={<EditorialArticle />} />
              <Route path="/Firstday" element={<EditorialArticle />} />
              <Route path="/RecruitmentMarketing" element={<EditorialArticle />} />
              {/* Agreements */}
              <Route path="/Privacypolicy" element={<Privacypolicy />} />
              <Route path="/TermsConditions" element={<TermsConditions />} />
              {/* Agreements */}
              <Route path="*" element={<main style={{padding: "140px 24px", minHeight: "60vh", textAlign: "center"}}><h1>Page not found</h1><p>The requested page is unavailable.</p><a href="/">Return to Quarec Resources</a></main>} />
            </Routes>
          </BrowserRouter>
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;
